"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useObserveScrollPosition;

var _react = require("react");

var _InternalContext = _interopRequireDefault(require("../ScrollToBottom/InternalContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function useObserveScrollPosition(observer) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (typeof observer !== 'function') {
    console.error('react-scroll-to-bottom: First argument passed to "useObserveScrollPosition" must be a function.');
  } else if (!Array.isArray(deps)) {
    console.error('react-scroll-to-bottom: Second argument passed to "useObserveScrollPosition" must be an array if specified.');
  }

  var _useContext = (0, _react.useContext)(_InternalContext.default),
      observeScrollPosition = _useContext.observeScrollPosition;
  /* eslint-disable-next-line react-hooks/exhaustive-deps */


  (0, _react.useEffect)(function () {
    return observer && observeScrollPosition(observer);
  }, [].concat(_toConsumableArray(deps), [observeScrollPosition]));
}